import { Box, Flex, Text, useMantineColorScheme } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { PerformanceBars } from "../PerformanceBars";
import { PlaceholderValue } from "../PlaceholderValue";
import { TextSerif } from "../TextSerif";

import type { FC } from "react";
import type { BarData } from "../PerformanceBars";

export type HammerPriceCardEmptyStateProps = {
  title: string;
  variant: "conditions" | "year";
};

const dummyData: BarData[] = [
  { label: "", value: 100 },
  { label: "", value: 80 },
  { label: "", value: 60 },
  { label: "", value: 40 },
  { label: "", value: 20 },
];

export const HammerPriceCardEmptyState: FC<HammerPriceCardEmptyStateProps> = ({ title }) => {
  const { t } = useTranslation();
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  return (
    <Box pos="relative" h={220}>
      <Box
        px="xs"
        h={240}
        style={{
          filter: "grayscale(1)",
          opacity: isDark ? 0.3 : 0.4,
          pointerEvents: "none",
        }}
      >
        <PerformanceBars
          align="left"
          data={dummyData}
          header={{
            left: t("components.HammerPriceCard.header.status"),
            right: t("components.HammerPriceCard.header.auction"),
          }}
          renderLabel={() => (
            <PlaceholderValue
              w="100%"
              color={isDark ? "#4e4f50" : "#D0D8EF"}
              lines={[{ w: 75, h: 8 }]}
            />
          )}
          renderValue={() => null}
          isEmptyState
        />
      </Box>

      <Flex
        align="center"
        justify="center"
        pos="absolute"
        inset={0}
        direction="column"
        gap={4}
        style={{
          borderRadius: 8,
        }}
      >
        <Text ta="center" fz={18} fw={500} lh="normal">
          {title}
        </Text>
        <TextSerif ta="center" fz={14} fw={400} lh="normal" c={isDark ? "#999" : "#6A6A84"}>
          {t("car.no_data_available")}
        </TextSerif>
      </Flex>
    </Box>
  );
};
